/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

//
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { MDMedia } from './media-data.js';

import { MPlugins } from './plugins.js';


export let MPreviewUtil = function($,mj) {

	function createPreview( dtinfo, target_elem, xopts, toolbar_elem ) {

		// find a preview_plugin candidate
		var preview_plugin = null;
		MPlugins.iterateByType('MediaPreview',function(name,plugin) {
			if( plugin.canCreatePreview(dtinfo) ) {
				preview_plugin = plugin;
				return false; // break out of iterateByType()
			}
		});

		if( preview_plugin!==null ) {
			// create using MediaPreview plugin
			preview_plugin.createPreview(dtinfo,target_elem,xopts);
		} else {
			// create using MC* implementation
			const media_class = dtinfo.hasOwnProperty('media_class') ? dtinfo.media_class : ( dtinfo.meta[-1] ? parseInt(dtinfo.meta[-1][0],10) : 0 );
			mj.mc_ns[media_class].createPreview(dtinfo,target_elem,xopts);
		}

		if( toolbar_elem ) {
			// setup toolbar
			// console.log({w:'TRIGGER mjstoolbarsetup',from:'web/js/manja/media-preview-util.js:34',is_triggered_here:undefined});
			$(target_elem).triggerHandler('mjstoolbarsetup',toolbar_elem);
		}
	}


	/**
	 * callback type `onAfterCreatePreviewCallback`
	 *
	 * @callback onAfterCreatePreviewCallback
	 * @param {Object} dtinfo
	 * @param {DOMElement} target_elem
	 * @param {Object} xopts
	 * @param {DOMElement|null} toolbar_elem
	 */


	/**
	 * MediaPreviewLoader constructor.
	 *
	 * example usage:
	 *  util = MPreviewUtil.createMediaPreviewLoader();
	 *  util.createPreviewWhenMediaPreviewAvailable(dtinfo,target_elem,xopts,toolbar_elem);
	 *  util.stop(); // stops loading
	 *
	 * @class
	 *
	 * @param {number} unavailable_retry_time	0 to skip retries and create preview, even if not yet available
	 */
	function MediaPreviewLoader( unavailable_retry_time ) {
		this.unavailable_retry_time = unavailable_retry_time || 0;
		this._timeout_id = null;
		this._start_media_id = null;
		this._try_create_preview = null;
		this._try_counter = 0;
		this._do_create_preview = null;
		this._after_create_preview_cb = null;
		this._cur_target_elem = null;
		this._cur_toolbar_elem = null;
	}

	MediaPreviewLoader.prototype = {

		/**
		 *
		 * @param {onAfterCreatePreviewCallback} cb
		 */
		onAfterCreatePreview: function( cb ) {
			this._after_create_preview_cb = cb;
		},

		/**
		 *
		 * @param {Object} dtinfo
		 * @param {DOMElement} target_elem
		 * @param {Object} xopts
		 * @param {DOMElement|null} toolbar_elem
		 */
		createPreviewWhenMediaPreviewAvailable: function( dtinfo, target_elem, xopts, toolbar_elem ) {

			this.removePreview();

			this._start_media_id = dtinfo.media_id;

			this._do_create_preview = function() {
				const self = this;
				$(target_elem)
					.off('.mjMPreviewUtil')
					.one('mjspreviewready.mjMPreviewUtil', function() {
						if( self._after_create_preview_cb ) {
							self._after_create_preview_cb(dtinfo,target_elem,xopts,toolbar_elem);
						}
					} );

				// setup new preview on canvas & setup toolbar
				MPreviewUtil.createPreview(dtinfo,target_elem,xopts,toolbar_elem);
				this._cur_target_elem = target_elem;
				this._cur_toolbar_elem = toolbar_elem;
				// if( this._after_create_preview_cb ) this._after_create_preview_cb(dtinfo,target_elem,xopts,toolbar_elem);
				this._try_create_preview = null;
				this._do_create_preview = null;
			};

			if( dtinfo.is_latest_version ) {
				// with availability querying ..
				this._try_counter = 0;
				this._try_create_preview = function() {
					this._timeout_id = null;
					if( dtinfo.media_id != this._start_media_id ) return; // stop - stop any late attempt ...
					this._try_counter ++;
					var self = this;
					MDMedia.queryMediaPreviewAvailable(
						dtinfo.media_id,
						function _preview_available_success( mid, available ) {
							if( !self || mid!=dtinfo.media_id || mid!=self._start_media_id ) return; // ignore late results
							if( !available && self.unavailable_retry_time > 0 ) {
								// retry after unavailable_retry_time ..
								self._timeout_id = setTimeout(
									function() {
										self._try_create_preview();
									},
									self.unavailable_retry_time
								);
							} else {
								// create preview now ..
								if( self._do_create_preview ) {
									self._do_create_preview();
								}
							}
						},
						function _preview_available_error( mid, err ) {
							if( !self || mid!=dtinfo.media_id || mid!=self._start_media_id ) return; // ignore late results
							// error & timeout handler - try again later
							self._timeout_id = setTimeout(
								function() {
									self._try_create_preview();
								},
								2250
							);
						},
						this._try_counter===1
					);
				};
				this._try_create_preview();
			} else {
				// without availability querying ..
				if( this._do_create_preview ) {
					this._do_create_preview();
				}
			}
		}, // createPreviewWhenMediaPreviewAvailable

		removePreview: function() {
			this.stop();
			if( this._cur_target_elem ) {
				try {
					$(this._cur_target_elem).triggerHandler('mjsclose');
				} catch( err ) {
					// ignore exceptions here
				}
				$(this._cur_target_elem)
					.off('.mjMPreviewUtil')
					.empty()
					.removeClass('error md-video-canvas md-audio-canvas')
					.css({backgroundColor:'',backgroundImage:''});
				this._cur_target_elem = null;
			}
			if( this._cur_toolbar_elem ) {
				$('.section,.separator',this._cur_toolbar_elem).remove();
				this._cur_toolbar_elem = null;
			}
		},

		stop: function() {
			if( this._timeout_id ) {
				clearTimeout(this._timeout_id);
				this._timeout_id = null;
			}
			this._start_media_id = null;
			this._try_create_preview = null;
			this._do_create_preview = null;
		},
	};

	return {
		createPreview,

		createMediaPreviewLoader: function( unavailable_retry_time ) {
			return new MediaPreviewLoader(unavailable_retry_time);
		},
	};
}(jQuery,mj); // namespace MPreviewUtil
